/** @format */

import APIRequest from "../utils/APIRequest";

export default class Approval {
  static getAllApproval = async () => {
    return await APIRequest.set(`v1/wabaapproval`, "GET");
  };

  static getApprovalID = async (id) => {
    return await APIRequest.set(`v1/wabaapproval/${id}`, "GET");
  };

  static getApprovalByWABAID = async (id) => {
    return await APIRequest.set(`v1/wabaapproval/getbywabaid/${id}`, "GET");
  };

  static postApproval = async (body) => {
    return await APIRequest.set(`v1/wabaapproval`, "POST", body);
  };

  static updateApproval = async (body, id) => {
    return await APIRequest.set(`v1/wabaapproval/${id}`, "PUT", body);
  };
}
